export default __webpack_public_path__ + "static/media/UploadSuccess.41218453.svg";